import sigliveServiceV1 from 'Service/sigliveServiceV1';

const deleteRoleAccess = async ({ id }) => {
  const { data } = await sigliveServiceV1({ method: 'DELETE', url: `/access/role/${id}` });

  return data;
};

export default deleteRoleAccess;
